"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoadingForm = void 0;
const react_1 = __importDefault(require("react"));
const __1 = require("..");
const LoadingForm = (props) => {
    const { isLoading, children } = props;
    const loadingOverlayProps = {
        isLoading,
        loadingMessage: '',
        modificators: 'bottom',
    };
    return (react_1.default.createElement(__1.LoadingOverlay, { ...loadingOverlayProps }, children));
};
exports.LoadingForm = LoadingForm;
//# sourceMappingURL=index.js.map